import React, { useEffect, useRef, useState } from "react";
import _, { get } from "lodash";
import api from "APP_ROOT/api";
import useDebounce from "../../../../hooks/useDebounce";

function Sum({ paginator }) {
  const [sum, setSum] = useState(null);
  const latestRequestRef = useRef(0);

  const debouncedSearchArgs = useDebounce(
    300,
    Object.entries(paginator.get("filters").toJS())
      .flatMap(pair => pair)
      .join("-")
  );

  useEffect(() => {
    const currentRequest = latestRequestRef.current + 1;
    latestRequestRef.current = currentRequest;
    api.salesOrders
      .search({
        include_sum: true,
        ...paginator.get("filters").toJS()
      })
      .then(({ data }) => {
        if (currentRequest === latestRequestRef.current) {
          setSum(get(data, "data.sum"));
        }

        return function cleanup() {};
      });
  }, debouncedSearchArgs);

  if (!sum) return null;

  return <span>/&nbsp;&nbsp;{sum}</span>;
}

export default Sum;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Search/Sum.jsx